import { ZealApiSuccessResponse } from "@zeal/common";

import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IGetDashboardCustomizationArgs,
  IGetDashboardCustomizationResponseData,
} from "./getDashboardCustomization.schema";

type SuccessResponse =
  ZealApiSuccessResponse<IGetDashboardCustomizationResponseData>;

export const getDashboardCustomization = (axios: IAxiosInstance) => {
  return async (params: IGetDashboardCustomizationArgs) => {
    try {
      const response = await axios.noRetry.get<SuccessResponse>(
        "/api/dashboard-customizations",
        { params }
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
